var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.25 21.9622V11.25C38.25 5.03775 33.2145 0 27 0C20.7832 0 15.75 5.03775 15.75 11.25V21.9622C11.6393 25.2607 9 30.3188 9 36C9 45.9405 17.0595 54 27 54C36.9405 54 45 45.9405 45 36C45 30.3188 42.3607 25.2607 38.25 21.9622ZM20.25 11.25C20.25 7.5285 23.2785 4.5 27 4.5C30.7215 4.5 33.75 7.5285 33.75 11.25V19.3207C31.6642 18.4748 29.3895 18 27 18C24.6105 18 22.3357 18.4748 20.25 19.3207V11.25ZM27 49.5C19.5548 49.5 13.5 43.4453 13.5 36C13.5 28.5548 19.5548 22.5 27 22.5C34.4452 22.5 40.5 28.5548 40.5 36C40.5 43.4453 34.4452 49.5 27 49.5ZM31.5 36C31.5 38.484 29.484 40.5 27 40.5C24.516 40.5 22.5 38.484 22.5 36C22.5 33.516 24.516 31.5 27 31.5C29.484 31.5 31.5 33.516 31.5 36Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4f967b6ae4c08788a5723c438315ae6d.svg";
export { ForwardRef as ReactComponent };